import { motion } from "framer-motion";
import { memo } from "react";
import SemAutorizacao from "../../components/SemAutorizacao/SemAutorizacao";
import React from "react";
import NavbarV3 from "../../components/NavbarV3/NavbarV3.tsx";

function MotionSemAutorizacao() {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			<NavbarV3 />
			<SemAutorizacao />
		</motion.div>
	);
}

export default memo(MotionSemAutorizacao);
